import "../component_style/project.css"
import pro1 from "../videos/he.mp4"
import pro2 from "../videos/antro.mp4"
import pro3 from "../videos/bb.mp4"
import Aos from "aos"
import js from "../image/js.svg"
import css from "../image/css.svg"
import html from "../image/html.svg"
import react from "../image/react.svg"
import nodejs from "../image/nodejs.png"
import redux from "../image/redux.svg"
import mongodb from "../image/mongo.webp"
import Bootstarap from "../image/bootstarp.svg"


import "aos/dist/aos.css"
import { useEffect } from "react"


export default function Project (){

    let shop_git="https://github.com/AkashPanda1701/pink-pot-9002/tree/main/Shopahoilc-App"
    let Bobi_git="https://github.com/soumyanil22/Group_project_bobbi_brown"
    let head_git="https://github.com/Nikhil-81/big_basket"
    let shop_Live="https://shoppaholic.netlify.app/"
    let Bobi_Live="https://wonderful-piroshki-728bef.netlify.app/#"
    let head_Live="https://bigbasket-gold.vercel.app/"
useEffect(()=>{
Aos.init({duration:1200,offset:200})
},[])
 
    return(
        <div className="about_project">
            <h1 Style={" font-size: 2rem; margin-bottom: 2rem;margin-left: 2rem;color:aliceblue"}><b>Projects</b></h1>
            <div className="Box1_project">

            <div className="pro_sec_1"  data-aos="fade-left" data-aos-offset="300"  data-aos-duration="1500" >
                <div>
                <h5 Style={"color:aliceblue;font-size: 1.2rem;"}  >Shopaholic.com</h5>
                <br/>
                <video  autoPlay muted loop ><source src={pro2} type='video/mp4'/></video>
                </div>
                <div>
                <ul>
                <li> Shopaholic is a leading fashion retailer offering compelling makeup and accessories for women.</li>
                        <li>Frontend build with React,Redux,Chackra Ui</li>
                        <li>Backend build with Node js,Express js,MongoDB Ui</li>
                        <li>Area of responsibility-Product Page and Single Product page Build the backend for Filter and sorting</li>
                        <li>Group Project.</li>
                        <li> Executed in 5 days.</li>

                    </ul>
                    <br/>
                    <button  className="project_view"  ><a href={shop_Live} target="blank" >View Live</a></button>
                    <button  className="project_repo" ><a href={shop_git} target="blank" >GitHub</a></button>

                </div>
            </div>
            <h6 className="stackHerad">Tools Used</h6>
            <div className="WorkStackk_big" >
                <div>

                <img src={react} />
                <p Style={"color:white"}>React</p>
                </div>
                <div>

                <img src={nodejs} />
                <p Style={"color:white"}>Node</p>
                </div>
                <div>

                <img src={redux} />
                <p Style={"color:white"}>redux</p>
                </div>
                <div>

                <img src={mongodb} />
                <p Style={"color:white"}>Mongodb</p>
                </div>
                <div>

                <img src={js} />
                <p Style={"color:white"}>Javascript</p>
                </div>
                <div>

                <img src={Bootstarap} />
                <p Style={"color:white"}>Bootstarap</p>
                </div>
            </div>
            </div>

            <div className="Box1_project">
            <div className="pro_sec_2" data-aos="fade-right" data-aos-offset="300"  data-aos-duration="1500" >
                <div>
            <h5 Style={"color:aliceblue;font-size: 1.2rem;"}  >BigBasket Clone</h5>
            <br/>

                <video  autoPlay muted loop ><source src={pro1} type='video/mp4'/></video>
                </div>
                <div>
                     
                <ul>    <li>Big Basket is one of the largest online grocery super market </li>
                        <li>Built with React using Bootstarap, from scratch.</li>
                        <li>Used React-routing for all the routes.</li>
                        <li>Used Node.js for implementing login & signup.</li>
                        <li>Collaborative project.</li>
                        <li>Area of responsibility-Cart page,responsiveness of entire website, worked on backend for login & signup</li>
                        <li> Executed in 5 days.</li>

                       

                    </ul>
                    <br/>
                    <button  className="project_view"  ><a href={head_Live} target="blank" >View Live</a></button>
                    <button  className="project_repo" ><a href={head_git} target="blank" >GitHub</a></button>
               
                </div>
            </div>
                <h6 className="stackHerad">Tools Used</h6>
                <div className="WorkStackk_big" >
                <div>

                <img src={react} />
                <p Style={"color:white"}>React</p>
                </div>
                <div>

                <img src={nodejs} />
                <p Style={"color:white"}>Node</p>
                </div>
                <div>

                <img src={redux} />
                <p Style={"color:white"}>redux</p>
                </div>
                <div>

                <img src={mongodb} />
                <p Style={"color:white"}>Mongodb</p>
                </div>
                <div>

                <img src={js} />
                <p Style={"color:white"}>Javascript</p>
                </div>
                <div>

                <img src={Bootstarap} />
                <p Style={"color:white"}>Bootstarap</p>
                </div>
            </div>
            </div>

            <div className="Box1_project">

            <div className="pro_sec_3" data-aos="fade-zoom-in" data-aos-offset="300"  data-aos-duration="1500" >
                <div>
            <h5 Style={"color:aliceblue;font-size: 1.2rem;"} >bobbibrown.com Clone</h5>
            <br/>

                <video  autoPlay muted loop ><source src={pro3} type='video/mp4'/></video>
                </div>
                <div>

                     <ul>
                        <li>An Women’s jeweler and cosmetic based website.</li>
                        <li>Built with Html css javascript.</li>
                        <li>Area of responsibility- Cart page and merging</li>
                        <li>Group project.</li>
                        <li> Executed in 5 days.</li>

                    </ul>
                    <br/>
                    <button  className="project_view"  ><a href={Bobi_Live} target="blank" >View Live</a></button>
                    <button  className="project_repo" ><a href={Bobi_git} target="blank" >GitHub</a></button>
                </div>
                </div>
                <h6 className="stackHerad">Tools Used</h6>
            <div className="WorkStackk" >
            <div>

<img src={js} />
<p Style={"color:white"} >JavaScript</p>
</div>
<div>

<img src={html} />
<p Style={"color:white"} >HTML</p>
</div>
<div>

<img src={css} />
<p Style={"color:white"} >CSS</p>
</div>
            </div>

            </div>

        </div>
    )
}